var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadCaretDown = function SvgFadCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.887 88.644c-15.683-.237-24.307 19.643-12.729 31.005 11.578 11.363 36.027 35.011 43.358 42.475 7.33 7.464 19.338 6.48 26.124.31 6.786-6.169 31.366-31.221 42.774-42.737 11.408-11.516 3.283-30.815-12.17-30.815s-71.675 0-87.357-.238z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.21 108.68c-1.562-1.554-1.041-2.805 1.173-2.794l82.449.427c2.21.011 2.723 1.275 1.145 2.823l-39.596 39.868c-1.578 1.547-2.728 1.547-4.283 0L85.21 108.68z",
    fill: "#FFF"
  }))));
};
export { SvgFadCaretDown as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-caret-down.1e293b60.svg";